export const formatRows = (listaItems = []) =>
  
  listaItems.map(item => ({
    id: item.ocd_id,
    prd_code: item.prd_code,
    art_descripcion: item.cache_Art?.art_descripcion ?? "sin dato",
    price: item.ocd_price ?? 0,
    quantity: item.ocd_quantity ?? 0,
    discount: item.ocd_discount_percentage ?? 0,
    total_amount: item.ocd_total_amount ?? 0,
    observacion: item.ocd_observacion ?? "",
  }));
